import React, { useState, ReactElement, useContext } from 'react';
import { OverlayTrigger, Tooltip, Button, OverlayTriggerProps } from 'react-bootstrap';
import { AppContext } from '../../../context/AppContext';

interface OverlayTooltipProps extends Omit<OverlayTriggerProps, 'overlay' | 'children'> {
  tooltipText: string;
  buttonContent: string | ReactElement;
  ariaLabel: string;
  testId: string;
  tooltipClassName: string;
  buttonClassName: string;
  buttonVariant?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyUp?: React.KeyboardEventHandler<HTMLButtonElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
  timeoutDuration?: number;
  childRef?: any;
  disabled?: boolean;
  style?: any;
}

const OverlayTooltip = ({
  tooltipText,
  buttonContent,
  ariaLabel,
  testId,
  tooltipClassName,
  buttonClassName,
  buttonVariant = 'none',
  onClick,
  disabled = false,
  placement = 'bottom-start',
  onKeyUp,
  childRef,
  onKeyDown,
  style,
  ...otherProps
}: OverlayTooltipProps) => {
  const [show, setShow] = useState<boolean>(false);
  const { isTouchDevice } = useContext(AppContext);

  const handleMouseEnter = () => {
    if (!isTouchDevice) {
      setShow(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setShow(false);
    }
  };
  const handleTouchStart = () => setShow(true);
  const handleTouchEnd = () => setShow(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <OverlayTrigger
      placement={placement}
      show={show}
      overlay={<Tooltip className={tooltipClassName}>{tooltipText}</Tooltip>}
      {...otherProps}
    >
      <Button
        aria-label={ariaLabel}
        data-testid={testId}
        className={buttonClassName}
        variant={buttonVariant}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        disabled={disabled}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        ref={childRef}
        style={style}
      >
        {buttonContent}
      </Button>
    </OverlayTrigger>
  );
};

export default OverlayTooltip;
